// // ####################### New download code #########################
// /* eslint-disable */
// import React, { useMemo, useState, useEffect } from "react";
// import styles from "./miniTableComp.module.css";

// const ReusableTableMini = ({ title, columns, data }) => {
//   const [showPopup, setShowPopup] = useState(false);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [sortedData, setSortedData] = useState([]);

//   useEffect(() => {
//     setSortedData([...data]);
//   }, [data]);

//   useEffect(() => {
//     if (sortConfig.key) {
//       const newSortedData = [...data].sort((a, b) => {
//         const aValue = a[sortConfig.key];
//         const bValue = b[sortConfig.key];
//         if (typeof aValue === 'number' && typeof bValue === 'number') {
//           return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
//         }
//         const aString = String(aValue || '');
//         const bString = String(bValue || '');
//         if (sortConfig.direction === 'asc') {
//           return aString.localeCompare(bString);
//         } else {
//           return bString.localeCompare(aString);
//         }
//       });
      
//       setSortedData(newSortedData);
//     } else {
//       setSortedData([...data]);
//     }
//   }, [sortConfig, data]);

//   const handleSort = (key) => {
//     if (sortConfig.key === key) {
//       if (sortConfig.direction === 'asc') {
//         setSortConfig({ key, direction: 'desc' });
//       } else {
//         setSortConfig({ key: null, direction: 'asc' });
//       }
//     } else {
//       setSortConfig({ key, direction: 'asc' });
//     }
//   };

//   const columnTotals = useMemo(() => {
//     const totals = {};
//     const dataToUse = sortConfig.key ? sortedData : data;

//     columns.forEach(col => {
//       totals[col.key] = 0;
//     });

//     dataToUse.forEach(row => {
//       columns.forEach(col => {
//         const value = row[col.key];
//         if (typeof value === "number" && !isNaN(value)) {
//           totals[col.key] += value;
//         }
//       });
//     });

//     Object.keys(totals).forEach(key => {
//       totals[key] = parseFloat(totals[key].toFixed(2));
//     });

//     return totals;
//   }, [columns, data, sortedData, sortConfig]);

//   const renderSortIcon = (key) => {
//     if (sortConfig.key !== key) {
//       return <span className={styles.sort_icon}>▲</span>;
//     }
    
//     if (sortConfig.direction === 'asc') {
//       return <span className={styles.sort_icon_active}>▲</span>;
//     }
    
//     return <span className={styles.sort_icon_active}>▼</span>;
//   };

//   // Function to download table as CSV
//   const downloadTableAsCSV = () => {
//     const dataToDownload = sortConfig.key ? sortedData : data;
    
//     // Create CSV headers
//     const headers = columns.map(col => `"${col.header}"`).join(',');
    
//     // Create CSV rows
//     const rows = dataToDownload.map(row => {
//       return columns.map(col => {
//         const value = row[col.key];
//         // Handle values with commas or quotes
//         if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
//           return `"${value.replace(/"/g, '""')}"`;
//         }
//         return `"${value}"`;
//       }).join(',');
//     });
    
//     // Add total row
//     const totalRow = columns.map((col, index) => {
//       if (index === 0) return '"Total"';
//       if (typeof columnTotals[col.key] === "number" && columnTotals[col.key] !== 0) {
//         return `"${columnTotals[col.key]}"`;
//       }
//       return '""';
//     }).join(',');
    
//     // Combine all CSV content
//     const csvContent = [headers, ...rows, totalRow].join('\n');
    
//     // Create blob and download link
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement('a');
//     const url = URL.createObjectURL(blob);
    
//     link.setAttribute('href', url);
//     link.setAttribute('download', `${title.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.csv`);
//     link.style.visibility = 'hidden';
    
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const renderTable = (isPopup = false) => (
//     <div className={`${styles.table_scroll} ${isPopup ? styles.popup_table_scroll : ''}`}>
//       <table className={`${styles.custom_table} ${isPopup ? styles.popup_table : ''}`}>
//         <thead>
//           <tr>
//             {columns.map((col, index) => (
//               <th 
//                 key={index} 
//                 style={{ width: col.width }}
//                 onClick={() => col.sortable && handleSort(col.key)}
//                 className={col.sortable ? styles.sortable_header : ""}
//               >
//                 {col.header}
//                 {col.sortable && renderSortIcon(col.key)}
//               </th>
//             ))}
//           </tr>
//         </thead>

//         <tbody>
//           {(sortConfig.key ? sortedData : data).map((row, rowIndex) => (
//             <tr key={rowIndex}>
//               {columns.map((col, colIndex) => (
//                 <td
//                   key={colIndex}
//                   className={col.alignRight ? styles.text_right : ""}
//                 >
//                   {row[col.key]}
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//         <tfoot>
//           <tr className={styles.total_row}>
//             {columns.map((col, index) => (
//               <td
//                 key={index}
//                 className={col.alignRight ? styles.text_right : ""}
//               >
//                 {typeof columnTotals[col.key] === "number" &&
//                 columnTotals[col.key] !== 0
//                   ? columnTotals[col.key]
//                   : index === 0
//                   ? "Total"
//                   : ""}
//               </td>
//             ))}
//           </tr>
//         </tfoot>
//       </table>
//     </div>
//   );

//   return (
//     <>
//       <div className={styles.table_container}>
//         <div className={styles.table_header_container}>
//           <div className={styles.button_group}>
//             <button 
//               className={styles.popup_button}
//               onClick={() => setShowPopup(true)}
//               title="Open table in popup"
//             >
//               {/* 📊 */}
//               &#8505;
//             </button>
//             <button 
//               className={styles.download_button}
//               onClick={downloadTableAsCSV}
//               title="Download table as CSV"
//             >
//               &#11123;
//             </button>
//           </div>
//           <div className={styles.table_header_title}>{title}</div>
//         </div>
//         {renderTable(false)}
//       </div>
//       {showPopup && (
//         <div className={styles.popup_overlay}>
//           <div className={styles.popup_container}>
//             <div className={styles.popup_header}>
//               <h3>{title}</h3>
//               <button 
//                   className={styles.download_button_popup}
//                   onClick={downloadTableAsCSV}
//                   title="Download table as CSV"
//                 >
//                   &#11123;
//                 </button>
//               <div className={styles.popup_buttons}>
                
//                 <button 
//                   className={styles.close_button}
//                   onClick={() => setShowPopup(false)}
//                 >
//                   ✕
//                 </button>
//               </div>
//             </div>
//             <div className={styles.popup_content}>
//               {renderTable(true)}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ReusableTableMini;

// ########################### New color code ###############################
// /* eslint-disable */
// import React, { useMemo, useState, useEffect } from "react";
// import styles from "./miniTableComp.module.css";

// const ReusableTableMini = ({ title, columns, data }) => {
//   const [showPopup, setShowPopup] = useState(false);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [sortedData, setSortedData] = useState([]);

//   useEffect(() => {
//     setSortedData([...data]);
//   }, [data]);

//   useEffect(() => {
//     if (sortConfig.key) {
//       const newSortedData = [...data].sort((a, b) => {
//         const aValue = a[sortConfig.key];
//         const bValue = b[sortConfig.key];
//         if (typeof aValue === 'number' && typeof bValue === 'number') {
//           return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
//         }
//         const aString = String(aValue || '');
//         const bString = String(bValue || '');
//         if (sortConfig.direction === 'asc') {
//           return aString.localeCompare(bString);
//         } else {
//           return bString.localeCompare(aString);
//         }
//       });
      
//       setSortedData(newSortedData);
//     } else {
//       setSortedData([...data]);
//     }
//   }, [sortConfig, data]);

//   const handleSort = (key) => {
//     if (sortConfig.key === key) {
//       if (sortConfig.direction === 'asc') {
//         setSortConfig({ key, direction: 'desc' });
//       } else {
//         setSortConfig({ key: null, direction: 'asc' });
//       }
//     } else {
//       setSortConfig({ key, direction: 'asc' });
//     }
//   };

//   const hasYellowBackground = (headerText) => {
//     if (!headerText) return false;
//     const text = String(headerText).toLowerCase();
//     return text.includes('1-3') || text.includes('yrs') || text.includes('years');
//   };

//   const hasOrangeBackground = (headerText) => {
//     if (!headerText) return false;
//     const text = String(headerText).toLowerCase();
//     return text.includes('>3') || text.includes('yrs') || text.includes('years');
//   };

//   const columnTotals = useMemo(() => {
//     const totals = {};
//     const dataToUse = sortConfig.key ? sortedData : data;

//     columns.forEach(col => {
//       totals[col.key] = 0;
//     });

//     dataToUse.forEach(row => {
//       columns.forEach(col => {
//         const value = row[col.key];
//         if (typeof value === "number" && !isNaN(value)) {
//           totals[col.key] += value;
//         }
//       });
//     });

//     Object.keys(totals).forEach(key => {
//       totals[key] = parseFloat(totals[key].toFixed(2));
//     });

//     return totals;
//   }, [columns, data, sortedData, sortConfig]);

//   const renderSortIcon = (key) => {
//     if (sortConfig.key !== key) {
//       return <span className={styles.sort_icon}>▲</span>;
//     }
    
//     if (sortConfig.direction === 'asc') {
//       return <span className={styles.sort_icon_active}>▲</span>;
//     }
    
//     return <span className={styles.sort_icon_active}>▼</span>;
//   };

//   const downloadTableAsCSV = () => {
//     const dataToDownload = sortConfig.key ? sortedData : data;
//     const headers = columns.map(col => `"${col.header}"`).join(',');

//     const rows = dataToDownload.map(row => {
//       return columns.map(col => {
//         const value = row[col.key];
//         if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
//           return `"${value.replace(/"/g, '""')}"`;
//         }
//         return `"${value}"`;
//       }).join(',');
//     });
    
//     const totalRow = columns.map((col, index) => {
//       if (index === 0) return '"Total"';
//       if (typeof columnTotals[col.key] === "number" && columnTotals[col.key] !== 0) {
//         return `"${columnTotals[col.key]}"`;
//       }
//       return '""';
//     }).join(',');

//     const csvContent = [headers, ...rows, totalRow].join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement('a');
//     const url = URL.createObjectURL(blob);
    
//     link.setAttribute('href', url);
//     link.setAttribute('download', `${title.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.csv`);
//     link.style.visibility = 'hidden';
    
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const renderTable = (isPopup = false) => (
//     <div className={`${styles.table_scroll} ${isPopup ? styles.popup_table_scroll : ''}`}>
//       <table className={`${styles.custom_table} ${isPopup ? styles.popup_table : ''}`}>
//         <thead>
//           <tr>
//             {columns.map((col, index) => (
//               <th 
//                 key={index} 
//                 style={{ width: col.width }}
//                 onClick={() => col.sortable && handleSort(col.key)}
//                 className={`${col.sortable ? styles.sortable_header : ""} ${
//                   hasOrangeBackground(col.header) ? styles.orange_header : ""
//                 }`}
//               >
//                 {col.header}
//                 {col.sortable && renderSortIcon(col.key)}
//               </th>
//             ))}
//           </tr>
//         </thead>

//         <tbody>
//           {(sortConfig.key ? sortedData : data).map((row, rowIndex) => (
//             <tr key={rowIndex}>
//               {columns.map((col, colIndex) => (
//                 <td
//                   key={colIndex}
//                   className={`${col.alignRight ? styles.text_right : ""} ${
//                     hasOrangeBackground(col.header) ? styles.orange_cell : ""
//                   }`}
//                 >
//                   {row[col.key]}
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//         <tfoot>
//           <tr className={styles.total_row}>
//             {columns.map((col, index) => (
//               <td
//                 key={index}
//                 className={`${col.alignRight ? styles.text_right : ""} ${
//                   hasOrangeBackground(col.header) ? styles.orange_cell : ""
//                 }`}
//               >
//                 {typeof columnTotals[col.key] === "number" &&
//                 columnTotals[col.key] !== 0
//                   ? columnTotals[col.key]
//                   : index === 0
//                   ? "Total"
//                   : ""}
//               </td>
//             ))}
//           </tr>
//         </tfoot>
//       </table>
//     </div>
//   );

//   return (
//     <>
//       <div className={styles.table_container}>
//         <div className={styles.table_header_container}>
//           <div className={styles.button_group}>
//             <button 
//               className={styles.popup_button}
//               onClick={() => setShowPopup(true)}
//               title="Open table in popup"
//             >
//               {/* 📊 */}
//               &#8505;
//             </button>
//             <button 
//               className={styles.download_button}
//               onClick={downloadTableAsCSV}
//               title="Download table as CSV"
//             >
//               &#11123;
//             </button>
//           </div>
//           <div className={styles.table_header_title}>{title}</div>
//         </div>
//         {renderTable(false)}
//       </div>
//       {showPopup && (
//         <div className={styles.popup_overlay}>
//           <div className={styles.popup_container}>
//             <div className={styles.popup_header}>
//               <h3>{title}</h3>
//               <button 
//                   className={styles.download_button_popup}
//                   onClick={downloadTableAsCSV}
//                   title="Download table as CSV"
//                 >
//                   &#11123;
//                 </button>
//               <div className={styles.popup_buttons}>
                
//                 <button 
//                   className={styles.close_button}
//                   onClick={() => setShowPopup(false)}
//                 >
//                   ✕
//                 </button>
//               </div>
//             </div>
//             <div className={styles.popup_content}>
//               {renderTable(true)}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ReusableTableMini;

// ######################### New colors added ##########################
/* eslint-disable */
import React, { useMemo, useState, useEffect } from "react";
import styles from "./miniTableComp.module.css";

const ReusableTableMini = ({ title, columns, data, DataTitle="" }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [sortedData, setSortedData] = useState([]);

  useEffect(() => {
    setSortedData([...data]);
  }, [data]);

  useEffect(() => {
    if (sortConfig.key) {
      const newSortedData = [...data].sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];
        if (typeof aValue === 'number' && typeof bValue === 'number') {
          return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
        }
        const aString = String(aValue || '');
        const bString = String(bValue || '');
        if (sortConfig.direction === 'asc') {
          return aString.localeCompare(bString);
        } else {
          return bString.localeCompare(aString);
        }
      });
      
      setSortedData(newSortedData);
    } else {
      setSortedData([...data]);
    }
  }, [sortConfig, data]);

  const handleSort = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === 'asc') {
        setSortConfig({ key, direction: 'desc' });
      } else {
        setSortConfig({ key: null, direction: 'asc' });
      }
    } else {
      setSortConfig({ key, direction: 'asc' });
    }
  };

  const hasYellowBackground = (headerText) => {
    if (!headerText) return false;
    const text = String(headerText).toLowerCase();
    // Match "1-3" with "yrs" or "years" in the same header text
    return text.includes('1-3') && (text.includes('yrs') || text.includes('years'));
  };

  const hasOrangeBackground = (headerText) => {
    if (!headerText) return false;
    const text = String(headerText).toLowerCase();
    // Match ">3" with "yrs" or "years" in the same header text
    return text.includes('>3') && (text.includes('yrs') || text.includes('years'));
  };

  const columnTotals = useMemo(() => {
    const totals = {};
    const dataToUse = sortConfig.key ? sortedData : data;

    columns.forEach(col => {
      totals[col.key] = 0;
    });

    dataToUse.forEach(row => {
      columns.forEach(col => {
        const value = row[col.key];
        if (typeof value === "number" && !isNaN(value)) {
          totals[col.key] += value;
        }
      });
    });

    Object.keys(totals).forEach(key => {
      totals[key] = parseFloat(totals[key].toFixed(2));
    });

    return totals;
  }, [columns, data, sortedData, sortConfig]);

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <span className={styles.sort_icon}>▲</span>;
    }
    
    if (sortConfig.direction === 'asc') {
      return <span className={styles.sort_icon_active}>▲</span>;
    }
    
    return <span className={styles.sort_icon_active}>▼</span>;
  };

  const downloadTableAsCSV = () => {
    const dataToDownload = sortConfig.key ? sortedData : data;
    const headers = columns.map(col => `"${col.header}"`).join(',');

    const rows = dataToDownload.map(row => {
      return columns.map(col => {
        const value = row[col.key];
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return `"${value}"`;
      }).join(',');
    });
    
    const totalRow = columns.map((col, index) => {
      if (index === 0) return '"Total"';
      if (typeof columnTotals[col.key] === "number" && columnTotals[col.key] !== 0) {
        return `"${columnTotals[col.key]}"`;
      }
      return '""';
    }).join(',');

    const csvContent = [headers, ...rows, totalRow].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `${title.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const renderTable = (isPopup = false) => (
    <div className={`${styles.table_scroll} ${isPopup ? styles.popup_table_scroll : ''}`}>
      <table className={`${styles.custom_table} ${isPopup ? styles.popup_table : ''}`}>
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th 
                key={index} 
                style={{ width: col.width }}
                onClick={() => col.sortable && handleSort(col.key)}
                className={`${col.sortable ? styles.sortable_header : ""} ${
                  hasYellowBackground(col.header) ? styles.yellow_header :
                  hasOrangeBackground(col.header) ? styles.orange_header : ""
                }`}
              >
                {col.header}
                {col.sortable && renderSortIcon(col.key)}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {(sortConfig.key ? sortedData : data).map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col, colIndex) => (
                <td
                  key={colIndex}
                  className={`${col.alignRight ? styles.text_right : ""} ${
                    hasYellowBackground(col.header) ? styles.yellow_cell :
                    hasOrangeBackground(col.header) ? styles.orange_cell : ""
                  }`}
                >
                  {row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className={styles.total_row}>
            {columns.map((col, index) => (
              <td
                key={index}
                className={`${col.alignRight ? styles.text_right : ""} ${
                  hasYellowBackground(col.header) ? styles.yellow_cell :
                  hasOrangeBackground(col.header) ? styles.orange_cell : ""
                }`}
              >
                {typeof columnTotals[col.key] === "number" &&
                columnTotals[col.key] !== 0
                  ? columnTotals[col.key]
                  : index === 0
                  ? "Total"
                  : ""}
              </td>
            ))}
          </tr>
        </tfoot>
      </table>
    </div>
  );

  return (
    <>
      <div className={styles.table_container}>
        <div className={styles.table_header_container}>
          <div className={styles.button_group}>
            <button 
              className={styles.popup_button}
              onClick={() => setShowPopup(true)}
              title="Open table in popup"
            >
              &#8505;
            </button>
            <button 
              className={styles.download_button}
              onClick={downloadTableAsCSV}
              title="Download table as CSV"
            >
              &#11123;
            </button>
          </div>
          {/* <div className={styles.table_header_title}>{title}</div> */}
          <div className={styles.table_header_title} title={DataTitle}>{title}</div>
        </div>
        {renderTable(false)}
      </div>
      {showPopup && (
        <div className={styles.popup_overlay}>
          <div className={styles.popup_container}>
            <div className={styles.popup_header}>
              <h3>{title}</h3>
              <button 
                  className={styles.download_button_popup}
                  onClick={downloadTableAsCSV}
                  title="Download table as CSV"
                >
                  &#11123;
                </button>
              <div className={styles.popup_buttons}>
                <button 
                  className={styles.close_button}
                  onClick={() => setShowPopup(false)}
                >
                  ✕
                </button>
              </div>
            </div>
            <div className={styles.popup_content}>
              {renderTable(true)}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReusableTableMini;